import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-007e647e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manage-devices-container" }
const _hoisted_2 = { class: "text-left font-weight-black cursor-pointer checkbox-cell" }
const _hoisted_3 = { class: "text-left font-weight-black" }
const _hoisted_4 = { class: "text-left font-weight-black" }
const _hoisted_5 = { class: "text-left font-weight-black" }
const _hoisted_6 = { class: "text-left font-weight-black" }
const _hoisted_7 = { class: "text-left font-weight-black" }
const _hoisted_8 = { class: "text-left font-weight-black" }
const _hoisted_9 = { class: "text-left font-weight-black" }
const _hoisted_10 = { class: "text-left font-weight-black" }
const _hoisted_11 = { class: "text-left font-weight-black" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-left font-weight-black" }
const _hoisted_14 = { class: "text-left font-weight-black" }
const _hoisted_15 = { class: "text-left font-weight-black" }
const _hoisted_16 = { class: "text-left font-weight-black" }
const _hoisted_17 = { class: "text-left font-weight-black" }
const _hoisted_18 = { class: "text-left font-weight-black" }
const _hoisted_19 = { class: "text-left font-weight-black" }
const _hoisted_20 = { class: "text-left font-weight-black" }
const _hoisted_21 = { class: "text-left font-weight-black" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-left font-weight-black" }, null, -1))
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "text-left px-0" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "no-hover" }
const _hoisted_27 = {
  colspan: "9",
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentContainerNavbar = _resolveComponent("ContentContainerNavbar")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_QrCodeModal = _resolveComponent("QrCodeModal")!
  const _component_CreateDeviceModal = _resolveComponent("CreateDeviceModal")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_EditDeviceModal = _resolveComponent("EditDeviceModal")!
  const _component_DeleteDeviceModal = _resolveComponent("DeleteDeviceModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ContentContainerNavbar, {
        title: _ctx.$t('i18n.manageDevicesTitle', { records: _ctx.filteredDevices().length }),
        button: "",
        buttonText: _ctx.$t('i18n.manageDevicesButtonText'),
        buttonEvent: "open-create-device-modal-btn",
        onOpenCreateDeviceModalBtn: _ctx.openCreateDeviceModal
      }, null, 8, ["title", "buttonText", "onOpenCreateDeviceModalBtn"]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
            key: 0,
            type: "table"
          }))
        : (_openBlock(), _createBlock(_component_v_table, {
            key: 1,
            class: "table",
            "fixed-header": "",
            hover: _ctx.deviceList.length !== 0
          }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_2, [
                    _createVNode(_component_v_icon, {
                      class: "cursor-pointer pr-6",
                      icon: _ctx.filterActive ? 'mdi-filter-remove' : 'mdi-filter-menu',
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterActive = !_ctx.filterActive))
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('i18n.name')), 1)
                  ]),
                  _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('i18n.description')), 1),
                  _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('i18n.location')), 1),
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('i18n.type')), 1),
                  _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('i18n.completionRedirectUrl')), 1),
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('i18n.ipAddress')), 1),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('i18n.shortURL')), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('i18n.associatedForm')), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('i18n.uniqueIdentifier')), 1),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('i18n.actions')), 1)
                ]),
                (_ctx.filterActive)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                      _createElementVNode("th", _hoisted_13, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.filters.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.name) = $event)),
                          density: "compact",
                          variant: "outlined",
                          "hide-details": true,
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("th", _hoisted_14, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.filters.description,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.description) = $event)),
                          density: "compact",
                          variant: "outlined",
                          "hide-details": true,
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("th", _hoisted_15, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.filters.location,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.location) = $event)),
                          density: "compact",
                          variant: "outlined",
                          "hide-details": true,
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("th", _hoisted_16, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.filters.type,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.type) = $event)),
                          density: "compact",
                          variant: "outlined",
                          "hide-details": true,
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("th", _hoisted_17, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.filters.completion_redirect_url,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.completion_redirect_url) = $event)),
                          density: "compact",
                          variant: "outlined",
                          "hide-details": true,
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("th", _hoisted_18, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.filters.ip_address,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.ip_address) = $event)),
                          density: "compact",
                          variant: "outlined",
                          "hide-details": true,
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("th", _hoisted_19, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.filters.short_url,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.short_url) = $event)),
                          density: "compact",
                          variant: "outlined",
                          "hide-details": true,
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("th", _hoisted_20, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.filters.form,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.form) = $event)),
                          density: "compact",
                          variant: "outlined",
                          "hide-details": true,
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("th", _hoisted_21, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.filters.uuid,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.uuid) = $event)),
                          density: "compact",
                          variant: "outlined",
                          "hide-details": true,
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _hoisted_22
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.deviceList.length !== 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDevices(), (device, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: "text-left"
                      }, [
                        _createElementVNode("td", null, _toDisplayString(device.name), 1),
                        _createElementVNode("td", null, _toDisplayString(device.description), 1),
                        _createElementVNode("td", null, _toDisplayString(device.location), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.deviceTypeName(device.type_id)), 1),
                        _createElementVNode("td", null, _toDisplayString(device.completion_redirect_url), 1),
                        _createElementVNode("td", null, _toDisplayString(device.ip_address), 1),
                        _createElementVNode("td", null, _toDisplayString(device.short_url), 1),
                        _createElementVNode("td", null, _toDisplayString(device.form_id !== null ? _ctx.formName(device.form_id) : null), 1),
                        _createElementVNode("td", null, _toDisplayString(device.uuid), 1),
                        _createElementVNode("td", _hoisted_24, [
                          (_ctx.deviceTypeName(device.type_id) === 'QRCODE')
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                onClick: ($event: any) => (_ctx.downloadQRCode(device)),
                                onDownloadComplete: _cache[10] || (_cache[10] = ($event: any) => (_ctx.resetQRModal())),
                                class: "cursor-pointer",
                                variant: "text",
                                size: "small",
                                icon: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: "mdi-qrcode-scan",
                                    size: "large"
                                  }),
                                  _createVNode(_component_v_tooltip, {
                                    activator: "parent",
                                    location: "start"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('i18n.downloadQRCode')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                class: "cursor-pointer",
                                variant: "text",
                                size: "small",
                                icon: "",
                                onClick: ($event: any) => (_ctx.refreshDeviceContent(index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { icon: "mdi-play" }),
                                  _createVNode(_component_v_tooltip, {
                                    activator: "parent",
                                    location: "start"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('i18n.btnRefreshContent')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])),
                          _createVNode(_component_v_btn, {
                            class: "cursor-pointer",
                            variant: "text",
                            size: "small",
                            icon: "",
                            onClick: ($event: any) => (_ctx.openEditDeviceModal(index))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                icon: "$GoRateEdit"
                              }),
                              _createVNode(_component_v_tooltip, {
                                activator: "parent",
                                location: "start"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('i18n.btnEditDevice')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            class: "cursor-pointer",
                            variant: "text",
                            size: "small",
                            icon: "",
                            onClick: ($event: any) => (_ctx.openDeleteDeviceModal(index))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                icon: "$GoRateDeleteOutline"
                              }),
                              _createVNode(_component_v_tooltip, {
                                activator: "parent",
                                location: "start"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('i18n.btnDeleteDevice')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_25, [
                    _createElementVNode("tr", _hoisted_26, [
                      _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.$t('i18n.noDataAvailable')), 1)
                    ])
                  ]))
            ]),
            _: 1
          }, 8, ["hover"]))
    ]),
    (_ctx.qrCodeModalVisible && _ctx.selectedQRCode)
      ? (_openBlock(), _createBlock(_component_QrCodeModal, {
          key: 0,
          tinyUrl: _ctx.selectedQRCode.short_url,
          label: _ctx.selectedQRCode.name,
          logoName: "icon-only.png",
          onDownloadComplete: _cache[11] || (_cache[11] = ($event: any) => (_ctx.resetQRModal())),
          onQrcodeError: _cache[12] || (_cache[12] = ($event: any) => (_ctx.appStore.addAlert('error', 'Error creating QR Code.')))
        }, null, 8, ["tinyUrl", "label"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.createDeviceModalIsActive,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.createDeviceModalIsActive) = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CreateDeviceModal, {
          currentDeviceList: _ctx.deviceList,
          onCloseModal: _ctx.closeCreateDeviceModal
        }, null, 8, ["currentDeviceList", "onCloseModal"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.editDeviceModalIsActive,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editDeviceModalIsActive) = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        (_ctx.selectedDevice)
          ? (_openBlock(), _createBlock(_component_EditDeviceModal, {
              key: 0,
              currentDeviceList: _ctx.deviceList,
              device: _ctx.selectedDevice,
              onCloseModal: _ctx.closeEditDeviceModal
            }, null, 8, ["currentDeviceList", "device", "onCloseModal"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.deleteDeviceModalIsActive,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.deleteDeviceModalIsActive) = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DeleteDeviceModal, {
          deviceID: _ctx.selectedDeviceID,
          onCloseModal: _ctx.closeDeleteDeviceModal
        }, null, 8, ["deviceID", "onCloseModal"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}